var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.25C5.58579 6.25 5.25 6.58579 5.25 7C5.25 7.41421 5.58579 7.75 6 7.75L6 6.25ZM18 7.75C18.4142 7.75 18.75 7.41421 18.75 7C18.75 6.58579 18.4142 6.25 18 6.25V7.75ZM6 7.75L7 7.75L7 6.25L6 6.25L6 7.75ZM6.25 7V18H7.75V7H6.25ZM8 19.75H16V18.25H8V19.75ZM17 7.75L18 7.75V6.25L17 6.25V7.75ZM17.75 18V7H16.25V18H17.75ZM7 7.75L10 7.75V6.25L7 6.25L7 7.75ZM10.75 7V6H9.25V7H10.75ZM11 5.75H13V4.25H11V5.75ZM10 7.75H14V6.25H10V7.75ZM14 7.75L17 7.75V6.25L14 6.25V7.75ZM13.25 6V7H14.75V6H13.25ZM9.75 9.98252V16H11.25V9.98252H9.75ZM14.25 16V9.98252H12.75V16H14.25ZM10.75 6C10.75 5.86193 10.8619 5.75 11 5.75V4.25C10.0335 4.25 9.25 5.0335 9.25 6H10.75ZM16 19.75C16.9665 19.75 17.75 18.9665 17.75 18H16.25C16.25 18.1381 16.1381 18.25 16 18.25V19.75ZM13 5.75C13.1381 5.75 13.25 5.86193 13.25 6H14.75C14.75 5.0335 13.9665 4.25 13 4.25V5.75ZM6.25 18C6.25 18.9665 7.0335 19.75 8 19.75V18.25C7.86193 18.25 7.75 18.1381 7.75 18H6.25Z",
    fill: "#88919A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove_icon.3d51fef8c7ac029270da0f7bfd3f5220.svg";
export { ForwardRef as ReactComponent };